<template>
  <div class="life-page">
    <section class="life-panel">
      <div class="life-panel__head">
        <h2 class="life-panel__title">扫码事件查询</h2>
      </div>
      <div class="life-filter">
        <el-input v-model="filters.plateId" placeholder="码牌ID" clearable style="width: 170px" @keyup.enter.native="search" />
        <el-select v-model="filters.channel" placeholder="渠道" clearable style="width: 150px">
          <el-option label="微信扫码" value="WECHAT_SCAN" />
          <el-option label="鸿蒙扫码" value="HARMONY_SCAN" />
          <el-option label="NFC" value="NFC" />
          <el-option label="其他浏览器" value="OTHER_BROWSER" />
        </el-select>
        <el-select v-model="filters.resultCode" placeholder="结果" clearable style="width: 120px">
          <el-option label="成功" value="SUCCESS" />
          <el-option label="失败" value="FAIL" />
        </el-select>
        <el-button type="primary" icon="el-icon-search" @click="search">查询</el-button>
        <el-button icon="el-icon-refresh" @click="reset">重置</el-button>
      </div>
    </section>

    <section class="life-panel">
      <div class="life-panel__head">
        <h2 class="life-panel__title">事件列表</h2>
      </div>
      <el-table v-loading="loading" :data="rows" border>
        <el-table-column prop="entryTraceId" label="追踪ID" width="200" />
        <el-table-column prop="plateId" label="码牌ID" width="150" />
        <el-table-column label="渠道" width="110" align="center">
          <template slot-scope="scope">
            {{ channelName(scope.row.channel) }}
          </template>
        </el-table-column>
        <el-table-column prop="clientPlatform" label="平台" width="100" align="center" />
        <el-table-column label="路由" width="150">
          <template slot-scope="scope">
            {{ routeName(scope.row.route) }}
          </template>
        </el-table-column>
        <el-table-column label="结果" width="70" align="center">
          <template slot-scope="scope">
            <el-tag :type="scope.row.resultCode === 'SUCCESS' ? 'success' : 'danger'" size="small">
              {{ scope.row.resultCode === 'SUCCESS' ? '成功' : '失败' }}
            </el-tag>
          </template>
        </el-table-column>
        <el-table-column prop="resultMsg" label="描述" min-width="150" />
        <el-table-column prop="occurredAt" label="事件时间" width="170" />
      </el-table>
      <el-pagination class="life-pagination" :current-page.sync="page.current" :page-size="page.size"
        :page-sizes="[10, 20, 50]" :total="page.total"
        layout="total, sizes, prev, pager, next, jumper"
        @size-change="changeSize" @current-change="load" />
    </section>
  </div>
</template>

<script>
import { listScanEvents } from '@/api/aggregateCode/aggregateCodeApi'

export default {
  name: 'AggregateCodeScanEventList',
  data() {
    return {
      loading: false, rows: [],
      filters: { plateId: '', channel: '', resultCode: '' },
      page: { current: 1, size: 10, total: 0 }
    }
  },
  created() { this.load() },
  methods: {
    async load() {
      this.loading = true
      try {
        const res = await listScanEvents({ ...this.filters, page: this.page.current, row: this.page.size })
        this.rows = res.data || []
        this.page.total = Number(res.total || 0)
      } catch (error) {
        this.$message.error(error.message || '加载扫码事件失败')
      } finally { this.loading = false }
    },
    search() { this.page.current = 1; this.load() },
    reset() { this.filters = { plateId: '', channel: '', resultCode: '' }; this.search() },
    changeSize(size) { this.page.size = size; this.load() },
    channelName(c) {
      return { WECHAT_SCAN: '微信扫码', HARMONY_SCAN: '鸿蒙扫码', NFC: 'NFC', OTHER_BROWSER: '其他浏览器' }[c] || c
    },
    routeName(r) {
      return { WECHAT_MINI_PROGRAM: '微信小程序', HARMONY_META_SERVICE: '鸿蒙元服务', FALLBACK: '兜底页', INVALID: '无效' }[r] || r
    }
  }
}
</script>

<style lang="scss" scoped>
@import './life.scss';
</style>
